import axios from 'axios';
import vue from '@/main';

const locationToRedirect = '/login';

function getAuthentication() {
	const token = vue.$session.get('token');

	return token || 'none';
}

function authenticateAllRoutes(config) {
	config.headers.common.token = getAuthentication();

	return config;
}

function redirectIfUnauthorized(error) {
	if (error && error.response && error.response.status === 401) {
		sessionStorage.clear();
		window.location = locationToRedirect;
	}

	return Promise.reject(error);
}

/**
 * Build
 * funcao responsavel por definir os valores padrao para acesso das rotas do sistema
 * imediatamente apos a instancia do Vue ser criada os dados de http devem ser modificados
 */
const standard = axios.create({
	baseURL: process.env.VUE_APP_API_ENDPOINT,
	timeout: 1800000,
	headers: {
		'Access-Control-Allow-Origin': '*',
	},
});

/**
 * Interceptor
 * adiciona o token a requisicao
 */
standard.interceptors.request.use(authenticateAllRoutes, (error) => Promise.reject(error));

/**
 * Interceptor
 * responsavel por retornar o usuário a tela inicial
 * caso alguma requisicao retorne o codigo 401
 */
standard.interceptors.response.use((response) => response, redirectIfUnauthorized);

export default standard;
